import { useMemo } from "react";
import { buildVariantTree, getChildren, VariantCatalogItem } from "./VariantTableHelper";

/**
 * Builds the variant tree from structural catalog items only.
 */
export const useVariantTree = (catalogItems: VariantCatalogItem[]) => {
    const tree = useMemo(() => buildVariantTree(catalogItems), [catalogItems]);
    const rootItems = useMemo(() => getChildren(tree, null), [tree]);

    return { tree, rootItems };
};
